import { render } from "./Index.vue?vue&type=template&id=4c914220"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4c914220&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\demo\\three-3d-earth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__